export const GET_CONTACTS_REQUEST  = "profile/GET_CONTACTS_REQUEST"
export const GET_CONTACTS_RECEIVED = "profile/GET_CONTACTS_RECEIVED"
export const GET_CONTACTS_ERROR    = "profile/GET_CONTACTS_ERROR"

export const POST_CONTACT_REQUEST  = "profile/POST_CONTACT_REQUEST"
export const POST_CONTACT_RECEIVED = "profile/POST_CONTACT_RECEIVED"
export const POST_CONTACT_ERROR    = "profile/POST_CONTACT_ERROR"

export const DELETE_CONTACT_REQUEST  = "profile/DELETE_CONTACT_REQUEST"
export const DELETE_CONTACT_RECEIVED = "profile/DELETE_CONTACT_RECEIVED"
export const DELETE_CONTACT_ERROR    = "profile/DELETE_CONTACT_ERROR"


/** WEBPACK FOOTER **
 ** ./src/actions/profile/contacts/types.js
 **/